var exports = {
  "PJ": "ChannelLayout.module__channelLayoutContainer___WC0tNl",
  "Ei": "ChannelLayout.module__channelNotFoundContainer___WC0tNl",
  "Ck": "ChannelLayout.module__channelNotFoundContent___WC0tNl",
  "I8": "ChannelLayout.module__channelNotFoundIcon___WC0tNl",
  "lV": "ChannelLayout.module__channelNotFoundTitle___WC0tNl",
  "f2": "ChannelLayout.module__channelNotFoundDescription___WC0tNl",
};

module.exports = exports;
